module.exports = __webpack_public_path__ + "static/media/shelfzone.032ad80b.png";